/**
 * 라인업 — `/products` 인덱스의 SSOT (2026-09-09, judahsWeb/SITEMAP_PLAN.md §8.2·§9).
 *
 * 세 층을 자리별로 나눠 쓴다:
 * - 라인 이름(Koinos · Kedem)   → 메뉴 라벨·행 제목(워드마크)
 * - 풀네임 · 코드                → 행 키커 ("PROGRAMMABLE LOOP SWITCHER · PLS")
 * - 제품 표시명                  → 카드 제목 (PRODUCT_NAMES.md)
 *
 * 값의 원천은 Studio `kedemUpdater/src/profiles.js` 의 라인 정의
 * ({ brand: "Koinos", model: "PLS", desc: "Programmable Loop Switcher" } / { brand: "KEDEM", model: "MCS", desc: "MIDI Control System" }).
 * Utility 는 라인이 아니라 카테고리 — 워드마크·코드 없음.
 *
 * **배열 순서가 곧 화면 순서다** (서브 네비 `MonolithProductNav` 도 이 순서를 편다).
 * 단종된 라인은 맨 아래에 둔다 — 2026-09-16 부터 Kedem 이 그 자리다.
 */

/** 단종 표기. 카피는 PERSONA §1 단정문 — 사실만 쓰고 "성공적으로" 류 형용사를 쓰지 않는다 */
export interface ProductLineStatusType {
	/** 키커 급 라벨 */
	label: string
	/** 사실 한 줄 */
	line: string
	/** 쓰던 사람에게 남는 것 */
	note: string
}

export interface ProductLineItemType {
	/** 소문자 제품 코드 = URL (`/products/{code}`) */
	code: string
	/** 표시명 (PRODUCT_NAMES §1) */
	name: string
	/** 카드 한 줄. 사양 하나만, 형용사 없이 */
	summary: string
	/** 단종 제품이면 카드 제목 옆에 칩 하나 */
	discontinued?: boolean
}

export interface ProductLineType {
	/** 앵커 id (`/products#koinos`) */
	id: 'koinos' | 'kedem' | 'utility'
	/** 라인 이름. 워드마크가 있으면 페이지에서 워드마크로 그린다 */
	name: string
	/** 키커 풀네임. Utility 는 없음 */
	fullName?: string
	/** 키커 코드. Utility 는 없음 */
	lineCode?: string
	/** 단종된 라인이면 헤드에 상태 줄이 선다 */
	status?: ProductLineStatusType
	products: ProductLineItemType[]
}

export const productLineList: ProductLineType[] = [
	{
		id: 'koinos',
		name: 'Koinos',
		fullName: 'Programmable Loop Switcher',
		lineCode: 'PLS',
		products: [
			{
				code: 'pls8',
				name: 'Koinos PLS 8',
				summary: '8 loops, buffered insert, 8.88-inch touch display.',
			},
		],
	},
	{
		id: 'utility',
		name: 'Utility',
		products: [
			{
				code: 'amp2',
				name: 'AirMIDI POG 2',
				summary: 'Wireless MIDI preset switching for the Electro-Harmonix POG2.',
			},
			{
				code: 'ds',
				name: 'Dual Switch',
				summary: 'Two momentary footswitches over one TRS cable.',
			},
		],
	},
	{
		id: 'kedem',
		name: 'Kedem',
		fullName: 'MIDI Control System',
		lineCode: 'MCS',
		status: {
			label: 'Discontinued',
			line: 'The first generation sold out. Every unit we built has an owner.',
			note: 'Manuals and firmware stay here.',
		},
		products: [
			{
				code: 'kdm6',
				name: 'Kedem 6',
				summary: 'Six switches, 3.5-inch touch display, AirMIDI wireless.',
				discontinued: true,
			},
			{
				code: 'kdm4',
				name: 'Kedem 4',
				summary: 'Four switches, the same display and wireless, smaller footprint.',
				discontinued: true,
			},
		],
	},
]
